import { computed } from "vue";
import { useI18n } from "vue-i18n";
export function useRelationFunctionOptions() {
    const { t } = useI18n();
    const functionOptions = computed(() => [
        { value: "direction", label: t("contact.detail.relations.create.catalogue.direction") },
        { value: "commerce_sales", label: t("contact.detail.relations.create.catalogue.commerceSales") },
        { value: "marketing_communication", label: t("contact.detail.relations.create.catalogue.marketingCommunication") },
        { value: "tech_it", label: t("contact.detail.relations.create.catalogue.techIT") },
        { value: "finance_management", label: t("contact.detail.relations.create.catalogue.financeManagement") },
        { value: "human_resources", label: t("contact.detail.relations.create.catalogue.humanResources") },
        { value: "support_customer_service", label: t("contact.detail.relations.create.catalogue.supportCustomerService") },
        { value: "legal_compliance", label: t("contact.detail.relations.create.catalogue.legalCompliance") },
        { value: "purchases_logistics", label: t("contact.detail.relations.create.catalogue.purchasesLogistics") },
        { value: "other", label: t("contact.detail.relations.create.catalogue.other") },
    ]);
    return { functionOptions };
}
